export const useStoreMap = defineStore('StoreMap', {
    state: () => ({
        home: null,
        last: null,
    }),
    actions: {
        async getInitPosition() {
            if (this.last) return Promise.resolve(this.last);
            if (this.home) return Promise.resolve(this.home);
            return this.geolocateCurrentUser({enableHighAccuracy: false, timeout: 5000})
                .then((position) => {
                    console.log('Current User Position', position.coords.latitude, position.coords.longitude);
                    this.home = {lat: position.coords.latitude, lng: position.coords.longitude, zoom: 6};
                    this.last = this.home;
                    return this.home;
                })
                .catch((e) => {
                    console.log('Error getting Current User Position, using Default Position', e);
                    this.home = {lat: 51.3764894, lng: -2.3527513, zoom: 6};
                    this.last = this.home;
                    return this.home;
                });
        },
        async geolocateCurrentUser(options) {
            return new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject, options));
        },
        setLastPosition(position) {
            this.last = position;
        },
    },
});
